import { Observable, map } from "rxjs";
import { IProfile } from ".";
import { BidClient } from "../core/clients";
import { axiosToObservable } from "../core/clients/axiosToObservable";

export class ProfileService {
    getProfile = (): Observable<IProfile> => {
        return axiosToObservable(BidClient.get<IProfile>('Policy/user-info/')).pipe(
            map((profile: IProfile) => {
                return profile;
            })
        );
  };
}
